import { SignIn } from '@clerk/clerk-react';
import PlayClawAuthLayout from '@/app/layout/PlayClawAuthLayout';
import { buildAuthPageUrl, getPlayClawRedirectUrl } from '@/lib/redirects';

const SignInPage = () => {
  const redirectUrl = getPlayClawRedirectUrl();
  const signUpUrl = buildAuthPageUrl('/sign-up');

  return (
    <PlayClawAuthLayout redirectUrl={redirectUrl}>
      <SignIn
        routing="path"
        path="/sign-in"
        signUpUrl={signUpUrl}
        fallbackRedirectUrl={redirectUrl}
        signUpFallbackRedirectUrl={redirectUrl}
      />
    </PlayClawAuthLayout>
  );
};

export default SignInPage;
